import React from 'react';
import StyleButton from './StyleButton';
import './InlineStyleControls.css';

const INLINE_STYLES = [
  {label: 'Bold', style: 'BOLD'},
  {label: 'Italic', style: 'ITALIC'},
  {label: 'Underline', style: 'UNDERLINE'},
];

class InlineStyleControls extends React.Component {

  render() {
    const { editorState, onToggle } = this.props;

    const currentStyle = editorState.getCurrentInlineStyle();

    return (
      <span className="RichEditor-controls">
        {INLINE_STYLES.map(type =>
          <StyleButton
            key={type.label}
            active={currentStyle.has(type.style)}
            label={type.label}
            onToggle={onToggle}
            style={type.style}
          />
        )}
      </span>
    );
  }
}

export default InlineStyleControls;
